import { createAsyncThunk } from '@reduxjs/toolkit'
import { AxiosClient } from 'src/redux/AxiosClient'

export const fileDownload = createAsyncThunk('alix/fileDownload', async (payload, toolkit) => {
  return await AxiosClient(
    'GET',
    `/v1/risk-management/compliance-scoreboard/download-report?supplierId=${payload.supplierId}&clientId=${payload.clientId}`,
    {},
    toolkit,
  )
})
